import React from 'react';
import { authValidation } from '../../../utils/authValidation';

const PasswordStrengthMeter = ({ password }) => {
  const strength = authValidation.getPasswordStrength(password);
  
  const getStrengthConfig = () => {
    switch (strength) {
      case 0:
        return { label: "", color: "bg-gray-200", width: "0%" };
      case 1:
        return { label: "Weak", color: "bg-red-500", width: "25%" };
      case 2:
        return { label: "Fair", color: "bg-orange-500", width: "50%" };
      case 3:
        return { label: "Good", color: "bg-blue-500", width: "75%" };
      case 4:
        return { label: "Strong", color: "bg-green-500", width: "100%" };
      default:
        return { label: "", color: "bg-gray-200", width: "0%" };
    }
  };

  const config = getStrengthConfig();

  if (!password) return null;

  return (
    <div className="mt-2 mb-4">
      <div className="flex justify-between items-center mb-1">
        <span className="text-xs font-medium text-gray-500">Password Strength</span>
        <span className={`text-xs font-bold ${config.color.replace('bg-', 'text-')}`}>
          {config.label}
        </span>
      </div>
      <div className="h-1.5 w-full bg-gray-200 rounded-full overflow-hidden">
        <div 
          className={`h-full ${config.color} transition-all duration-300 ease-in-out`}
          style={{ width: config.width }}
        ></div>
      </div>
    </div>
  );
};

export default PasswordStrengthMeter;
